var baseURL, imgURL, posUrl, wsURL;
if (process.env.NODE_ENV == "development") {
    baseURL = '/api';
} else if (process.env.NODE_ENV == "test") {
    // baseURL = 'http://61.132.52.38:8001/dnnCloud/interface';
    baseURL = 'http://58.213.48.52:7899/dnnCloud/interface'  // 测试
} else {
    // baseURL = 'http://106.14.238.88:8080/dnnCloud/interface';
    baseURL = 'https://dev.eicad.net/dnnCloud/interface'; // 打包后端地址
    // baseURL = 'http://58.213.48.52:7899/dnnCloud/interface'  // 樊
}


export {
    baseURL,
    wsURL,
    imgURL
}



// WEBPACK FOOTER //
// ./src/api/config.js